var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 16,
    viewBox: "0 0 10 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.571.007L1.43 0C.643 0 0 .655 0 1.455v13.09C0 15.345.643 16 1.429 16H8.57C9.357 16 10 15.345 10 14.545V1.455c0-.8-.643-1.448-1.429-1.448zm0 13.084H1.43V2.909H8.57v10.182z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMCIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDEwIDE2Ij4KICA8cGF0aCBkPSJNOC41NzE0Mjg1NywwLjAwNzI3MjcyNzI3IEwxLjQyODU3MTQzLDAgQzAuNjQyODU3MTQzLDAgMCwwLjY1NDU0NTQ1NSAwLDEuNDU0NTQ1NDUgTDAsMTQuNTQ1NDU0NSBDMCwxNS4zNDU0NTQ1IDAuNjQyODU3MTQzLDE2IDEuNDI4NTcxNDMsMTYgTDguNTcxNDI4NTcsMTYgQzkuMzU3MTQyODYsMTYgMTAsMTUuMzQ1NDU0NSAxMCwxNC41NDU0NTQ1IEwxMCwxLjQ1NDU0NTQ1IEMxMCwwLjY1NDU0NTQ1NSA5LjM1NzE0Mjg2LDAuMDA3MjcyNzI3MjcgOC41NzE0Mjg1NywwLjAwNzI3MjcyNzI3IFogTTguNTcxNDI4NTcsMTMuMDkwOTA5MSBMMS40Mjg1NzE0MywxMy4wOTA5MDkxIEwxLjQyODU3MTQzLDIuOTA5MDkwOTEgTDguNTcxNDI4NTcsMi45MDkwOTA5MSBMOC41NzE0Mjg1NywxMy4wOTA5MDkxIFoiLz4KPC9zdmc+Cg==";
export { SvgMobile as ReactComponent };